import React from 'react';
import Button from '../../shared/form/Button'

const DepositUpload = ({ hide, submit, fname, loading, change }) => {
    if (hide) return '';

    return (
        <div>
            <h2>Upload Deposit slip</h2>

            <form onSubmit={submit}>
                <div className="form-item form-type-file form-item-files-file-receipts">
                <input onChange={change} name="filename" type="file" id="edit-file-receipts" size="60" className="form-file" tabIndex="-1" style={{position: 'absolute', clip: 'rect(0px 0px 0px 0px)'}} />
                <div className="bootstrap-filestyle input-group">
                    <span className="group-span-filestyle " tabIndex="0">
                    <label htmlFor="edit-file-receipts" className="btn">Upload <br/>{fname}</label>
                    </span>
                </div>
                </div>
                <div className="description">Accepted file format jpeg,jpg,png,gif and pdf</div>

                <Button loading={loading} htmlClass="pull-right">Submit</Button>
            </form>
          </div>
    );
}
 
export default DepositUpload;